export default __webpack_public_path__ + "assets/wind-beaufort-0.e4dba835.svg";